import { render, staticRenderFns } from "./BacRadio.vue?vue&type=template&id=479d25d9&scoped=true&"
import script from "./BacRadio.vue?vue&type=script&lang=ts&"
export * from "./BacRadio.vue?vue&type=script&lang=ts&"
import style0 from "./BacRadio.vue?vue&type=style&index=0&id=479d25d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479d25d9",
  null
  
)

export default component.exports